import { LabelNames } from "../shared/core/ovs.core";

export class ResortHeaderLabelNames {
    public static Hello = 'hello_user';
    public static AccountNumber = 'account_number';
    public static PointsBalance = 'points_balance';
    public static PremierPoints = 'premier_points';
    public static LogIn = LabelNames.Login;
    public static LogOut = LabelNames.SignOut;
    public static SignUp = 'sign_up';
    public static MyReservations = 'my_reservations';
    public static MyAccountHRef = LabelNames.MyAccountHRef;
    public static AccountSettings = LabelNames.AccountSettingsLabel;
    public static ContactUsToBook = 'contact_us_to_book';
    public static ContactHeaderText = LabelNames.ContactHeaderText;

    public static Redeem = LabelNames.RedeemText;
    public static RedeemHref = LabelNames.RedeemHRef;

    public static Welcome = LabelNames.Welcome;
    public static SoftCurrencyLongName = LabelNames.SoftCurrenyLongName;
    public static SoftCurrencySymbol = 'soft_currency_symbol';
    public static MyAccount = "account_settings_label";
    public static ContactUs = 'contact_us';
    public static Or = 'or';
    public static Balance = LabelNames.Balance;
    public static Login = LabelNames.Login;
    public static SignOut = LabelNames.SignOut;
    public static SignOutHref = LabelNames.SignOutHRef;
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/header/resort-header-labels-names.ts